import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import config from '../config'

export default class Footer extends Component {
    render() {
        return (
            <div>
                <div className="clear" />
                <footer>
                    <div className="f_navigation">
                        <div className="container_12">
                            <div className="grid_4">
                                <h3>Contact Us</h3>
                                <ul className="f_contact">
                                    <li><address>{config.address}</address></li>
                                    <li>{config.phoneNo}</li>
                                    <li>{config.mail}</li>
                                </ul>
                            </div>
                            <div className="grid_4">
                                <h3>Information</h3>
                                <nav className="f_menu">
                                    <ul>
                                        <li><Link to="/about-us">About Us</Link></li>
                                        <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                        <li><Link to="/terms-and-conditions">Terms &amp; Conditions</Link></li>
                                        {/* <li><Link to="#">Secure payment</Link></li> */}
                                    </ul>
                                </nav>
                            </div>
                            <div className="grid_4">
                                <h3>Costumer Servise</h3>
                                <nav className="f_menu">
                                    <ul>
                                        <li><Link to="/contact-us">Contact Us</Link></li>
                                        {/* <li><Link to="#">Return</Link></li> */}
                                        {/* <li><Link to="#">FAQ</Link></li> */}
                                        {/* <li><Link to="#">Site Map</Link></li> */}
                                    </ul>
                                </nav>
                            </div>
                            {/* <div className="grid_3">
                                <h3>My Account</h3>
                                <nav className="f_menu">
                                    <ul>
                                        <li><Link to="#">My Account</Link></li>
                                        <li><Link to="#">Order History</Link></li>
                                        <li><Link to="#">Wish List</Link></li>
                                        <li><Link to="#">Newsletter</Link></li>
                                    </ul>
                                </nav>
                            </div> */}
                            <div className="clear" />
                        </div>
                    </div>
                    <div className="f_info">
                        <div className="container_12">
                            <div className="grid_6">
                                <p className="copyright">© N S Solution, 2021</p>
                            </div>
                            <div className="clear" />
                        </div>
                    </div>
                </footer>
            </div>
        )
    }
}
